import React, {Component} from 'react';
import {DataSearch, ReactiveBase} from '@appbaseio/reactivesearch';
import {Button, ButtonGroup, Col, FormControl, FormGroup, Modal, Row} from 'react-bootstrap';
import {fetch_mockups_by_category_paged} from './actions'
import {fetch_categories} from '../../components/navBar/actions'
import {Link, Redirect, withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import './style.css';
import PlaceHolder from '../../components/placeholder';
import InfinteScroll from "react-infinite-scroll-component";
import {hide_upload_image_modal, show_upload_image_modal} from '../MockupPage/actions';
import Masonry from 'react-masonry-component';
import {useMediaQuery} from 'react-responsive'

class Home extends Component {
	constructor(props) {
        super(props);
        this.state = {
            mockups : [],
            page_no : 1,
            size : 30,
            active_category : {
                _id : "all",
                name: "All mockups"
            },
            saved_designs: null,
            show_grab_image_url_modal: false,
            redirect_page: false,
            redirect_url: null,
            images_loaded: false,
            is_desktop: true,
            is_tablet: false,
        };
        window.apply_category_filter = this.apply_category_filter;
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    redirect_page = (url) => {
        this.setState({redirect_url:url,redirect:true})
    }

    assign_window_size = () => {
        if (window.innerWidth > 991) {
            this.set_state({is_desktop: true, is_tablet: false});
        } else {
            this.set_state({is_desktop: false, is_tablet: true});
        }
    }

    componentDidMount() {
        this.props.fetch_categories()
        .then(() => {
        	this.gen_mockups({_id: "all", name: "All"})
        })

        //responsiveness
        this.assign_window_size();
        window.onresize = this.assign_window_size;

        window.modify_auto_crop_mockups = this.modify_auto_crop_mockups
    }

    componentDidUpdate(prev_props) {
        if (this.props.search_value != prev_props.search_value) {
            this.fetch_search_results(this.props.search_value)
        }
    }

    gen_mockups = (category) => {
        fetch_mockups_by_category_paged(category._id, this.state.page_no, this.state.size)
        .then(data => {
            var mockup_ids = this.state.mockups.map(x => x._id);
            var extra_mockups = data.filter(x => !mockup_ids.includes(x._id))
            // extra_mockups = extra_mockups.sort((a, b) => (a.priority < b.priority ? 1 : -1))

            this.setState({
                mockups : this.state.mockups.concat(extra_mockups),
                page_no: this.state.page_no + 1
            });
        });
    }

    fetch_more_data = () => {
        this.gen_mockups(this.state.active_category)
    }

    modify_auto_crop_mockups = () => {
        var inputs = inputs =  {
            hue_values: [{h: 63.82, s: 1, l: 0.368, a: 1},{h: 198.21, s: 1, l: 0.439, a: 1},{h: 298.60, s: 1, l: 0.578, a: 1}],
            user_images: [
                {src:global.config.static_file_server_path+'uploads/design_resources/design_thumbnails/5cf02984b4ebfd540878f6dd.jpg'},
                {src:global.config.static_file_server_path+'uploads/design_resources/design_thumbnails/5cf02984b4ebfd540878f6dd.jpg'},
                {src:global.config.static_file_server_path+'uploads/design_resources/design_thumbnails/5cf02984b4ebfd540878f6dd.jpg'},
                {src:global.config.static_file_server_path+'uploads/design_resources/design_thumbnails/5cf02984b4ebfd540878f6dd.jpg'},
                {src:global.config.static_file_server_path+'uploads/design_resources/design_thumbnails/5cf02984b4ebfd540878f6dd.jpg'},
                {src:global.config.static_file_server_path+'uploads/design_resources/design_thumbnails/5cf02984b4ebfd540878f6dd.jpg'}
            ]
        }

        window.syncForEach(this.state.mockups,function(mockup,index,this_as_param){
            return window.cropAndGenerateMockup(mockup,inputs,'zoom')
            .then(imgData => {
                mockup.placeholders = [imgData]
                var mockups_state = this_as_param.state.mockups;
                mockups_state[index] = mockup
                console.log(this_as_param,mockups_state)
                return this_as_param.set_state({
                    mockups : mockups_state
                })
            }).catch(err => Promise.reject(err))
        },this).then(() => {
            this.setState({
                mockups : this.state.mockups
            });
        }).catch(() => {
            this.setState({
                mockups : this.state.mockups
            });
        })
    }

    generate_mockup_card(mockup) {
        var images = []
        if(mockup.placeholders && mockup.placeholders.length>0){
            images = mockup.placeholders.map(o => (o.indexOf('data:image')>-1 || o.indexOf('http')>-1 || o.indexOf('blob:')>-1)?o:global.config.static_file_server_path+o)
        }else{
            images = [global.config.static_file_server_path+mockup.tracing_image_src]
        }

        // const isTablet = useMediaQuery({maxWidth: 991})


		return (
            <div style={{marginBottom: 20, marginLeft: 20, boxShadow: '0 5px 20px 0 rgba(0,0,0,0.1)'}}>
				<Link style={{cursor:"pointer"}} to={"/mockupmaker/start/mockups/"+mockup._id}><PlaceHolder width={this.state.is_tablet ? 230 : 230} images_loaded={this.state.images_loaded} mockup={mockup} images={[...images]}/></Link>
    		</div>	
        );

    }

    generate_mockup_view(col_number) {
    	var result_html = [];
    	for(let i = col_number; i < (this.state.mockups? this.state.mockups.length : 0); i+=3) {
            if(this.state.mockups[i].active){
        		let inner_row = this.generate_mockup_card(this.state.mockups[i])
        		result_html.push(inner_row)
            }
    	}
    	return result_html;
    }

    apply_category_filter = cat => {
        this.set_state({page_no: 1, active_category : cat, mockups: []})
        .then(() => this.gen_mockups(cat))
    }

    category_list() {
        var result_html = [];
        result_html.push(
            <Button key="category-list-btn-213" className=" category_list_button"  onClick={() => {this.set_state({page_no: 1, active_category : {_id: "all", name: "All Mockups"}, mockups: []}).then(() => this.gen_mockups({_id: "all", name: "All Mockups"}))}}>All Mockups</Button>
        )
        this.props.categories.filter(x => (x.mockup_length > 0)).map((cat, idx) => {
            result_html.push(
                <Button key={"category_"+idx+"_btn"} className=" category_list_button" style={{cursor: "pointer"}} onClick={() => window.apply_category_filter(cat)}>{cat.name}<span style={{float: 'right'}}>{cat.mockup_length}</span></Button>
            )
        })
        return result_html;
    }

    crop_and_generate_preview = (mockup, index, upload_src, this_as_param)  => {
        var inputs = inputs =  {
            hue_values: [],
            user_images: [{src:upload_src}]
        }

        var mockups_state = this_as_param.state.mockups;
        mockup.show_loader_gif = true
        mockups_state[index] = mockup
        return this_as_param.set_state({
            mockups : mockups_state
        }).then(() => {
            return window.cropAndGenerateMockup(mockup,inputs,'zoom')
            .then(imgData => {
                mockup.placeholders = [imgData]
                mockup.show_loader_gif = false
                var mockups_state = this_as_param.state.mockups;
                mockups_state[index] = mockup
                console.log(this_as_param,mockups_state)
                return this_as_param.set_state({
                    mockups : mockups_state
                })
            }).catch(err => Promise.reject(err))
        })
    }

    generate_mockup_previews = (uploaded_image_src) => {
        window.syncForEach(this.state.mockups, this.crop_and_generate_preview, uploaded_image_src, this)
    }

    generate_mockup_previews_wrapper_file_upload = () => {
        var image_src = window.fetchFileSrc('upload_image_input');

        image_src.then(src => {
            this.generate_mockup_previews(src)
        })
    }

    generate_mockup_previews_wrapper_url_grab = () => {
        var src = window.document.getElementById('grab_url_input').value
        this.grab_image_url_modal_close()

        this.generate_mockup_previews(src)
    }



    grab_image_url_modal_close = () => {
        this.setState({
            show_grab_image_url_modal : false
        })
    }
    show_grab_image_url_modal = () => {
        this.setState({
            show_grab_image_url_modal : true
        })
    }

    fetch_search_results = (query_str) => {
        var url = global.config.server_path+'mockups/_search?'

        var query_body = {
            "from" : 0,
            "size" : 100,
            "query": {
              "multi_match" : {
                "query": query_str,
                "fields": [ "name", "categories.name", "keywords"],
                "operator" : "or",
                "type" : "best_fields",
              }
            }
          }

        return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(query_body)})
        .then(resp => resp.json())
        .then(resp => Promise.resolve(resp.hits.hits.map(x => x._id)))
        .then(resp => {
            var url = global.config.server_path+'mockup/get/';
            console.log(resp);
            return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : resp})})
        })
        .then(resp => resp.json())
        .then(data => this.setState({mockups : data.data}))
        .catch(err => console.log(err))
    }

    render() {

        var {redirect, redirect_url} = this.state;
        if (redirect) {
            return (<Redirect push to={redirect_url} />)
        }

        const Desktop = ({ children }) => {
            const isDesktop = useMediaQuery({minWidth: 992})
            return isDesktop ? children : null
        }
        
        const Tablet = ({ children }) => {
            const isTablet = useMediaQuery({maxWidth: 991})
            return isTablet ? children : null
        }

        const grab_url_modal = (
            <Modal show={this.state.show_grab_image_url_modal} onHide={this.grab_image_url_modal_close}>
                <Modal.Header closeButton>
                  <Modal.Title>Grab Screenshot from URL</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">  
                    <form>
                        <Row>
                            <Col xs={10}>
                                <FormGroup>
                                <FormControl id="grab_url_input" type="text" placeholder="Enter Image Url"/></FormGroup>    
                            </Col>
                            <Col xs={2}>
                                <Button  className="btn-blue" type="button" onClick={() => this.generate_mockup_previews_wrapper_url_grab()}>Go</Button>
                            </Col>
                        </Row>

                    </form>
                </Modal.Body>
            </Modal>            
        )
        const image_upload_text = (
            <div style={{width: '100%', display: 'inline-block', marginBottom: 20}}>
                <Row>  
                    <h4 style={{marginTop: 0, 'textAlign': 'center'}}> Try out your image on all {this.state.active_category.name}</h4>
                </Row>
                <Row style={{'textAlign': 'center'}}>
                    <ButtonGroup>
                        <Button className="btn-blue" style={{marginRight:"5px"}} onClick={() => window.document.getElementById("upload_image_input").click()}>
                            <input id="upload_image_input" class="upload_image" style={{"display": "none"}} type="file" onInput={() => this.generate_mockup_previews_wrapper_file_upload()}></input>
                            Upload Image
                        </Button>
                        <Button className="btn-blue" onClick={this.show_grab_image_url_modal}>Grab From Url</Button>
                    </ButtonGroup>
                </Row>
            </div>
        )

        const Mockups_List = (
            <div id="mockup_result_container" style={{width: '-webkit-fill-available', marginLeft: this.state.is_tablet ? 45 : 275}}>
                <div id="mockup_container">
                    {(this.state.active_category._id != "all")?image_upload_text:''}
                    <InfinteScroll  style={{minHeight: 800, overflowY: 'hidden'}}
                        dataLength={this.state.mockups ? this.state.mockups.length : 0}
                        next= {this.fetch_more_data}
                        hasMore={true}
                        endMessage={<h4>No more results.</h4>} 
                    >
                        <Masonry style={{height: '100%'}}
                            className={'mockup-results'}
                            elementType={'ul'} 
                            options={{transitionDuration: 100}}
                            updateOnEachImageLoad={false}
                        >
                           {this.state.mockups && this.state.mockups.length && this.state.mockups.map(x => this.generate_mockup_card(x))}    
                        </Masonry>
                    </InfinteScroll>
                </div>
            </div>
        )

        return (
            <div style={{paddingTop: 75}}>
                {grab_url_modal}
                
                <div style={{marginTop: 50, marginBottom: 40, width: '100%'}}>
                    <div style={{width: 500, margin: 'auto'}}> 
                        <div style={{'textAlign': 'center'}}>
                            <span style={{fontFamily: 'Montserrat', fontWeight: '800', fontSize: 36}}>Create amazing product<br /> mockups easily</span>
                        </div>
                        <div style={{marginTop: 20, paddingLeft: 5, paddingRight: 5}}>
                            <div style={{'background': "white", "width": "100%"}}>
                                <ReactiveBase app="mockups" style={{position: 'relative'}} url={global.config.server_path}>
                                    <DataSearch
                                        componentId="mainSearch"
                                        dataField={["name", "categories.name", "keywords", "description"]}
                                        queryFormat="or"
                                        className="mockup_search"
                                        innerClass={{
                                            "input": "mockup_search_box",
                                            "list": "suggestionlist"
                                        }}
                                        placeholder={"All mockups"}
                                        showIcon={false}
                                        onValueSelected={(value) => {
                                            this.fetch_search_results(value);
                                        }}
                                        renderSuggestion={(suggestion) => {console.log(suggestion); return {
                                            label: suggestion.source.categories ? (<div><Row>{suggestion.source.name}</Row><Row> <span style={{color : '#2572CE', textAlign : 'right'}}> in {suggestion.source.categories[0].name}</span></Row></div>) : (<div style={{color : '#2572CE', textAlign : 'right'}}>{suggestion.source.name}</div>),
                                            value : suggestion.source.name,
                                            source : suggestion.source
                                        }}}
                                    />
                                    <span style={{position: 'absolute', right: 7, fontSize: 28, top: 7, zIndex: 100, color: '#F1F1F1'}} className="fas fa-search fa-2x" />
                                </ReactiveBase>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{width: '100%', paddingLeft: 45, paddingRight: 43}}>
                    <div style={{width: '100%', paddingBottom: 20, display: 'inline-block'}}>
                        <span style={{float: 'left', fontFamily: 'Montserrat', fontSize: 18, fontWeight: 800}}>All Results</span>
                    </div>
                    <div style={{width: '100%'}}>
                        {this.state.is_desktop && (
                            <div style={{width: 275, float: 'left', position: 'sticky', top: 100, boxShadow: '0 5px 20px 0 rgba(0,0,0,0.1)'}} id="category_list_container">
                                <ul className="category_list">
                                    <ButtonGroup vertical block>
                                        {this.category_list()}
                                    </ButtonGroup>
                                </ul>
                            </div>
                        )}
                        {Mockups_List}
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        show_upload_mockup_modal: state.display_upload_mockup_modal,
        categories: state.categories,
        search_value: state.search_value
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetch_categories: () => {
            return dispatch(fetch_categories())
        },
        show_upload_image_modal: () => {
            dispatch(show_upload_image_modal())
        },

        hide_upload_image_modal: () => {
        	dispatch(hide_upload_image_modal())
        },

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));